<template>
  <div>
    <div
      ref="modal"
      class="modal fade"
      :class="{ show: active, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">History Proforma Invoice</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              v-on:click="$emit('closeModal')"
              aria-label="btn-close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="res.length > 0">
              <div class="row" v-for="(data, index) in res" :key="index">
                <div class="col-4">
                  <p>Load Id : {{ data.load_id }}</p>
                  <p>Shipment Number : {{ data.shipment_numbers }}</p>
                  <p>Sold To Party Name : {{ data.sold_to_party }}</p>
                  <p>{{$t('loadingDate')}} : {{ data.loading_date }}</p>
                  <p>{{$t('unloadingDate')}} : {{ data.unloading_date }}</p>
                </div>
                <div class="col-4">
                  <p v-for="(sub,index) in data.sub" :key="index">
                    {{ sub.charge_code_header_name }} : {{ parseFloat(sub.value) }}
                  </p>
                </div>
                <div class="col-4">
                  <p>Created At : {{ data.created_at }}</p>
                  
                </div>
                <hr style="width: 100%;color: black; height: 3px;">
              </div>
            </div>

            <div v-else>
              <div class="row" style="text-align: center">
                <div class="col-12">Empty Log</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              {{ $t("close_txt") }}
            </button>
            <!-- <button
              class="btn btn-success"
              type="submit"
              :disabled="isLoading"
              @click="submitData"
              v-if="this.data.method == 'create'"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm ms-auto"
                role="status"
                aria-hidden="true"
              ></span>
              {{ $t("addDetail") }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalProformaInvoiceHistory",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  components: {},
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
        this.rows = [];
        this.totalRecords = 0;
        console.log(this.data);
        if (this.data?.data) {
          this.loadItems();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    // const startDate = new Date();
    // const endDate = new Date();
    return {
      isLoading: false,
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      active: this.showModal,
      fetchCompany: [],
      totalRecords: 0,
      dateFilter: {
        startDate: null,
        endDate: null,
      },
      forms: [],
      columns: [],
      rows: [],
      company: {},
      proforma_invoice_header_id: null,
      rowsSelection: null,
      additionalHeader: [],
      res: [],
    };
  },
  methods: {
    customDatePickerRange() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);

      let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return {
        Today: [today, today],
        Yesterday: [yesterday, yesterday],
        "This month": [thisMonthStart, thisMonthEnd],
        // 'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        "Last month": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      };
    },
    loadItems() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/proforma-invoice/detail/" +
        this.data?.data?.proforma_invoice_header_id;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.res = response.data.datas.logs;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                //this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?limit=10&name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    removeReadonly() {
      this.$nextTick(() => {
        const input = this.$refs.inputCompany.$el.querySelector(
          ".multiselect__input"
        );
        if (input && input.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },
  },
  mounted() {
    this.loadCompany();
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>
